<template>
  <el-dialog
    :title="$t('addChainInoutOrder.addTitle')"
    :visible.sync="dialogVisible"
    width="60%"
    @close="handleClose">
    <el-form :model="form" :rules="rules" ref="form" label-width="120px">
      <el-form-item :label="$t('addChainInoutOrder.supplierId')" prop="csId">
        <el-input 
          v-model="form.csId" 
          :placeholder="$t('addChainInoutOrder.supplierIdPlaceholder')">
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="submitForm">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveChainInoutOrder } from '@/api/goods/chainInoutOrderApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  data() {
    return {
      dialogVisible: false,
      form: {
        csId: '',
        shopId: ''
      },
      rules: {
        csId: [
          { required: true, message: this.$t('addChainInoutOrder.supplierIdRequired'), trigger: 'blur' },
          { max: 32, message: this.$t('addChainInoutOrder.supplierIdMaxLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.form.shopId = getShopId()
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            await saveChainInoutOrder(this.form)
            this.$message.success(this.$t('addChainInoutOrder.saveSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          } catch (error) {
            console.error('保存失败:', error)
          }
        }
      })
    }
  }
}
</script>